import React, { useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { useOnlineStatus } from '../../../hooks/onlineStatus';
import getValidationErrors from '../../../utils/getValidationErrors';

import BackHeader from '../../../components/BackHeader';
import Input from '../../../components/Form/Input';
import Button from '../../../components/Button';
import Offline from '../../../components/OfflineMessage';

import { Container, Content } from './styles';

interface NewPropertyData {
  nome: string;
  descricao: string;
  type: true | false;
}

const NewProperty: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const isOnline = useOnlineStatus();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: NewPropertyData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          nome: Yup.string().required('Nome obrigatório.'),
          descricao: Yup.string().required('Localização obrigatória.'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/propriedades', {
          nome: data.nome,
          descricao: data.descricao,
        });

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'A propriedade foi criada.',
        });

        history.push('/');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro!',
          description: err.response.data.message || 'Algo deu errado!',
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <Container>
      <BackHeader title="Nova propriedade" />

      {!isOnline ? (
        <Offline />
      ) : (
        <Content>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              label="Nome"
              name="nome"
              type="text"
              placeholder="Ex.: Fazenda e-Bov"
            />

            <Input
              label="Localização"
              name="descricao"
              type="text"
              placeholder="Ex: Aquidauana - MS"
            />

            <Button type="submit" isLoading={loading} style={{ marginTop: 60 }}>
              Salvar
            </Button>
          </Form>
        </Content>
      )}
    </Container>
  );
};

export default NewProperty;
